import lang from '@/lang/middleware/pages/customer-satisfaction/broadband';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const title = store.$i18n.t('broadband.title');
  const description = store.$i18n.t('broadband.description');
  store.commit('pageContent/setHead', { title, description });
};
